<template>
  <div>
    <div class="d-flex align-center mb-4">
      <span class="text-subtitle-2 grey--text text--darken-1">
        Contacto principal para Relbase (máximo 1)
      </span>
    </div>

    <div v-if="!contact && !editing">
      <v-btn
        v-if="$can('create', 'Contact')"
        color="primary"
        outlined
        small
        @click="startCreate"
      >
        <v-icon x-small class="mr-2">fas fa-plus</v-icon>
        Agregar Contacto
      </v-btn>
    </div>

    <div v-if="contact && !editing">
      <v-simple-table dense>
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Email</th>
            <th>Teléfono</th>
            <th>Cargo</th>
            <th class="text-end" width="60"></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ contact.first_name }} {{ contact.last_name }}</td>
            <td>{{ contact.email }}</td>
            <td>{{ contact.phone }}</td>
            <td>{{ contact.cargo }}</td>
            <td class="text-end">
              <v-btn icon x-small color="primary" @click="startEdit" class="mx-1">
                <v-icon x-small>fas fa-edit</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </div>

    <v-dialog v-model="editing" max-width="500" persistent>
      <v-card outlined class="modern-card overflow-hidden">
        <v-sheet color="grey lighten-4" class="px-6 py-4 border-bottom">
          <div class="d-flex align-center">
            <v-icon color="primary" class="mr-3">fas fa-user</v-icon>
            <div>
              <div class="text-h6 font-weight-bold lh-1">
                {{ isNew ? 'Crear Contacto' : 'Editar Contacto' }}
              </div>
              <div class="caption grey--text mt-1">
                Contacto principal para sincronización con Relbase
              </div>
            </div>
          </div>
        </v-sheet>

        <v-card-text class="pa-6 pt-8">
          <ValidationObserver v-slot="{ handleSubmit }">
            <v-form @submit.prevent="handleSubmit(submit)">
              <v-row dense>
                <v-col cols="12" md="6">
                  <ValidationProvider name="Nombres" rules="required" v-slot="{ errors }">
                    <v-text-field
                      v-model="form.first_name"
                      label="Nombres"
                      outlined dense
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="6">
                  <ValidationProvider name="Apellidos" rules="required" v-slot="{ errors }">
                    <v-text-field
                      v-model="form.last_name"
                      label="Apellidos"
                      outlined dense
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12">
                  <ValidationProvider name="Email" rules="required|email" v-slot="{ errors }">
                    <v-text-field
                      v-model="form.email"
                      label="Correo Electrónico"
                      outlined dense
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="6">
                  <ValidationProvider name="Teléfono" rules="required" v-slot="{ errors }">
                    <v-text-field
                      v-model="form.phone"
                      label="Teléfono"
                      outlined dense
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="12" md="6">
                  <ValidationProvider name="Cargo" rules="required" v-slot="{ errors }">
                    <v-text-field
                      v-model="form.cargo"
                      label="Cargo / Función"
                      outlined dense
                      :error-messages="errors"
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>

              <v-divider class="my-6"></v-divider>

              <div class="d-flex justify-end">
                <v-btn text small @click="cancel" class="mr-2" :disabled="loading">Cancelar</v-btn>
                <v-btn type="submit" color="primary" depressed small class="px-6" :loading="loading">
                  <v-icon x-small class="mr-2">fas fa-save</v-icon>
                  {{ isNew ? 'Registrar' : 'Actualizar' }}
                </v-btn>
              </div>
            </v-form>
          </ValidationObserver>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { createContact, updateContact } from '@/api/customers'
import notifications from '@/utils/notifications'

export default {
  name: 'ContactRelbase',
  props: {
    customerId: { type: Number, required: true },
    value: { type: Array, default: () => [] }
  },
  data: () => ({
    editing: false,
    isNew: true,
    loading: false,
    form: {
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      cargo: ''
    }
  }),
  computed: {
    contact() {
      return this.value && this.value.length > 0 ? this.value[0] : null
    }
  },
  methods: {
    startCreate() {
      this.isNew = true
      this.form = { first_name: '', last_name: '', email: '', phone: '', cargo: '' }
      this.editing = true
    },
    startEdit() {
      this.isNew = false
      this.form = {
        id: this.contact.id,
        first_name: this.contact.first_name,
        last_name: this.contact.last_name,
        email: this.contact.email,
        phone: this.contact.phone,
        cargo: this.contact.cargo
      }
      this.editing = true
    },
    async submit() {
      this.loading = true
      try {
        if (this.isNew) {
          const data = { ...this.form, customer: this.customerId }
          await createContact(data)
          notifications.showSuccess('Contacto creado correctamente')
        } else {
          await updateContact(this.form)
          notifications.showSuccess('Contacto actualizado correctamente')
        }
        this.$emit('updated')
        this.editing = false
      } catch (e) {
        notifications.showError('Error al guardar el contacto: ' + e)
      } finally {
        this.loading = false
      }
    },
    cancel() {
      this.editing = false
    }
  }
}
</script>

<style scoped>
.modern-card { border: 1px solid rgba(0,0,0,0.08) !important; }
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.08); }
.lh-1 { line-height: 1.2; }
</style>
